import { K_LOCAL_STORAGE_INBOX_SOUND } from "../constants";

//* Kept per browser, not on the shop: each admin's computer decides for itself whether it rings.
//* Default ON — a shop that has never touched the switch keeps the sound it had before.
export const isInboxSoundOn = () => {
    try {
        return localStorage.getItem(K_LOCAL_STORAGE_INBOX_SOUND) !== "OFF";
    } catch (e) {
        return true;
    }
};

export const setInboxSoundOn = (on) => {
    try {
        localStorage.setItem(K_LOCAL_STORAGE_INBOX_SOUND, on ? "ON" : "OFF");
    } catch (e) { /* storage blocked: the switch just will not stick */ }
};
